export default __webpack_public_path__ + "static/media/arrow-prev.1a840fee.svg";